import { Box } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import TextFieldCompnent from "../../../components/textFieldComponent";
import ButtonComponent from "../../../components/ButtonComponent";
import { useTranslation } from "react-i18next";

const CurrencyForm = ({
    buttonText,
    handleFormSubmit,
    initialValues,
    loading,
}) => {
    const { t } = useTranslation();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const currencySchema = yup.object().shape({
        name: yup.string().required("Nom est requis"),
        code: yup.string().required("Code est requis"),
        symbol: yup.string().required("Symbole est requis"),
    });

    return (
        <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={currencySchema}
        >
            {({
                values,
                errors,
                touched,
                handleBlur,
                handleChange,
                handleSubmit,
            }) => (
                <form
                    onSubmit={(e) => {
                        handleSubmit(e);
                    }}
                >
                    <Box
                        display="grid"
                        gap="16px"
                        gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
                        }}
                    >
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.name")}
                            change={handleChange}
                            value={values.name}
                            name="name"
                            blur={handleBlur}
                            touched={touched.name}
                            error={errors.name}
                            colum={"span 3"}
                            row="1 / span 1"
                            required
                        />
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.code")}
                            change={handleChange}
                            value={values.code}
                            name="code"
                            blur={handleBlur}
                            touched={touched.code}
                            error={errors.code}
                            colum={"span 3"}
                            row="2 / span 1"
                            required
                        />
                        <TextFieldCompnent
                            type="text"
                            label={t("fields.symbol")}
                            change={handleChange}
                            value={values.symbol}
                            name="symbol"
                            blur={handleBlur}
                            touched={touched.symbol}
                            error={errors.symbol}
                            colum={"span 3"}
                            row="3 / span 1"
                            required
                        />
                    </Box>
                    <ButtonComponent text={buttonText} loading={loading} />
                </form>
            )}
        </Formik>
    );
};

export default CurrencyForm;
